<template>
  <div>
    <el-tooltip
      :disabled="!selectedContent"
      :visible-arrow="false"
      :content="selectedContent"
      placement="top"
    >
      <el-select
        v-close-on-zoom
        :value="state.selectedQuestion"
        :placeholder="placeholder"
        :disabled="readonly"
        class="question-select"
        @input="questionId => selectQuestion(questionId)"
      >
        <el-option
          v-for="question in getDialogueItems(emitter.caseConf)"
          :key="question.id"
          :label="question.content.en"
          :value="question.id"
        />
      </el-select>
    </el-tooltip>
    <help-tooltip v-if="errors.length" type="error">
      <span v-for="error in errors" :key="error.message">{{ error.message }}</span>
    </help-tooltip>
  </div>
</template>

<script>
import { get, uniqBy } from 'lodash';
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'dialogue-action',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'actionType',
    'placeholder',
    'getDialogueItems'
  ],
  data() {
    return {
      state: {
        selectedQuestion: undefined,
      },
    };
  },
  computed: {
    selectedContent() {
      const items = this.getDialogueItems(this.emitter.caseConf) || [];
      const item = items.find(i => i.id === this.state.selectedQuestion);
      return get(item, 'content.en');
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(error => error.metadata && error.metadata.scope === 'control');

      return uniqBy(errors, 'message');
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.update();
  },
  methods: {
    syncState() {
      const data = this.getData(this.ikey);
      this.state.selectedQuestion = get(data, 'id');
    },
    selectQuestion(questionId) {
      this.state.selectedQuestion = questionId;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.actionType,
        id: this.state.selectedQuestion,
      });
      this.emitter.trigger('process', this.control);
    }
  },
};
</script>

<style>
</style>
